import { STEPS } from "@/lib/booking";

export const Stepper = ({ step }) => (
  <div aria-label="Booking progress" data-testid="booking-stepper">
    <div className="flex items-baseline justify-between gap-4">
      <span className="mono uppercase tracking-[0.16em] text-sec" data-testid="booking-progress-label">Step {step + 1} of {STEPS.length}</span>
      <span className="hidden sm:inline text-xs text-sec">{step < STEPS.length - 1 ? `Next: ${STEPS[step + 1]}` : "Secure checkout"}</span>
    </div>
    <div className="mt-2 h-[2px] w-full bg-divider" role="progressbar" aria-valuemin={1} aria-valuemax={STEPS.length} aria-valuenow={step + 1}>
      <div className="h-full bg-forest transition-[width] duration-300" style={{ width: `${((step + 1) / STEPS.length) * 100}%` }} />
    </div>
  </div>
);

export const ChoiceGroup = ({ label, options, value, onChange, testId, hint, hintMinH }) => (
  <fieldset>
    <legend className="label">{label}</legend>
    <div className="flex flex-wrap gap-2" role="radiogroup" data-testid={testId}>
      {options.map((o) => {
        const on = value === o.id;
        return (
          <button key={o.id} type="button" role="radio" aria-checked={on} onClick={() => onChange(o.id)} data-testid={`${testId}-${o.id}`} className={`chip ${on ? "chip-active" : "chip-idle"}`}>
            {o.label}
          </button>
        );
      })}
    </div>
    {(hint || hintMinH) && (
      <p className={`mt-2.5 text-sm text-sec leading-relaxed ${hintMinH ? "min-h-[2.5rem]" : ""}`} data-testid={`${testId}-hint`} aria-live="polite">{hint}</p>
    )}
  </fieldset>
);

export const Field = ({ id, label, optional, hint, error, ...props }) => (
  <div>
    <label htmlFor={id} className="label">
      {label} {optional && <span className="font-normal text-sec">(optional)</span>}
    </label>
    <input id={id} className={`field ${error ? "field-error" : ""}`} aria-invalid={Boolean(error)} aria-describedby={error ? `${id}-error` : undefined} {...props} />
    {error ? <p id={`${id}-error`} className="error-text" role="alert" data-testid={`${id}-input-error`}>{error}</p> : hint ? <p className="mt-1.5 text-xs text-sec">{hint}</p> : null}
  </div>
);
